import update from 'immutability-helper';
import moment from "moment";

import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';
import { LocalCacheHandler } from '~/utils/local-cache-handler';

import {
    LOAD_CONTAS_PAGAR,
    CREATE_CONTA_PAGAR,
    UPDATE_CONTA_PAGAR,
    DELETE_CONTA_PAGAR,
    MARK_AS_PAID,
} from './actions';

var DEFAULT_CACHE_KEY = CACHE_ACTIONS.contasPagar;

export var defaultState = {
    data: [],
    summary: {
        total: 0,
        pending: 0,
        paid: 0,
        overdue: 0,
        count_total: 0,
        count_pending: 0,
        count_paid: 0,
        count_overdue: 0,
    },
    filter: {
        from: moment().startOf("month").format("YYYY-MM-DD"),
        to: moment().endOf("month").format("YYYY-MM-DD"),
        status: "all",
    },
    isLoading: false,
};

var ACTION_HANDLERS = {
    [DEFAULT_CACHE_KEY]: function(state, action) {
        return action.payload;
    },

    [LOAD_CONTAS_PAGAR.INIT]: function(state, action) {
        return update(state, {
            isLoading: { $set: true },
        });
    },

    [LOAD_CONTAS_PAGAR.SUCCESS]: function(state, action) {
        return update(state, {
            isLoading: { $set: false },
            data: { $set: action.payload.data.data.records },
            summary: { $set: action.payload.data.data.summary },
            filter: { $set: action.meta.previousAction.payload.filter },
        });
    },

    [LOAD_CONTAS_PAGAR.FAIL]: function(state, action) {
        return update(state, {
            isLoading: { $set: false },
        });
    },

    [CREATE_CONTA_PAGAR.SUCCESS]: function(state, action) {
        return update(state, {
            data: { $unshift: [action.payload.data.data] },
        });
    },

    [UPDATE_CONTA_PAGAR.SUCCESS]: function(state, action) {
        var updatedRecord = action.payload.data.data;
        return update(state, {
            data: {
                $set: state.data.map(function(item) {
                    if (item.id === updatedRecord.id) {
                        return updatedRecord;
                    }
                    return item;
                }),
            },
        });
    },

    [DELETE_CONTA_PAGAR.SUCCESS]: function(state, action) {
        var deletedId = action.meta.previousAction.id;
        return update(state, {
            data: {
                $set: state.data.filter(function(item) {
                    return item.id !== deletedId;
                }),
            },
        });
    },

    [MARK_AS_PAID.SUCCESS]: function(state, action) {
        var updatedRecord = action.payload.data.data;
        return update(state, {
            data: {
                $set: state.data.map(function(item) {
                    if (item.id === updatedRecord.id) {
                        return updatedRecord;
                    }
                    return item;
                }),
            },
        });
    },
};

var reducer = function(state, action) {
    if (state === undefined) state = defaultState;

    var handler = ACTION_HANDLERS[action.type];
    if (!handler) return state;

    var newState = handler(state, action);

    var updateCache = [
        LOAD_CONTAS_PAGAR.SUCCESS,
    ].includes(action.type);

    if (updateCache) {
        LocalCacheHandler.save({
            pathname: DEFAULT_CACHE_KEY,
            data: newState,
        });
    }

    return newState;
};

export default reducer;
